import { useQuery } from "@tanstack/react-query";

import api from "@/common/utils/api";
import { orgQueryKeys } from "@/global-settings/data/orgQueryKeys";

export function useLinearCleanupIssueCandidateCount(
  orgId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: orgQueryKeys.linearCleanupIssueCandidates(orgId),
    queryFn: () =>
      api
        .get<"/orgs/:orgId/linear-cleanup-issue-candidates">(
          `/orgs/${orgId}/linear-cleanup-issue-candidates`,
        )
        .then((res) => res.data.count),
    enabled: options?.enabled !== false,
  });
}
